const queryPrefix = 'ai'

export enum AIQueryKeys {
  AIAnnotationText = `${queryPrefix}/ai-annotation-text`,
  AIObject = `${queryPrefix}/ai-object`,
  AIObjects = `${queryPrefix}/ai-objects`,
  AnnotationUniqueAIObjects = `${queryPrefix}/annotation-unique-ai-objects`,
  FormControlTags = `${queryPrefix}/form-control-tags`,
  LastUpdateTime = `${queryPrefix}/last-update-time`,
  NLPModel = `${queryPrefix}/nlp-model`,
  NLPModels = `${queryPrefix}/nlp-models`,
  Tags = `${queryPrefix}/tags`,
  VQAModel = `${queryPrefix}/vqa-model`,
  VQAModelForms = `${queryPrefix}/vqa-model-forms`,
  VQAModels = `${queryPrefix}/vqa-models`,
  VQAModelsForForm = `${queryPrefix}/vqa-models-for-form`,
}
